module.exports = __webpack_public_path__ + "static/media/combat.7985a35f.jpg";